import { useMutation } from 'react-query'
import { AxiosResponse } from 'axios'
import PyAPI from '../Python/APIs/PyAPI'
import { useUserContext } from '../../Contexts/UserConfig'
import { useHoldingContext } from '../../Contexts/CurrentHolding'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'

export function useReaderValidate(
  sourceBatch: boolean,
  setContainerSelectionModel: any,
  setVesselSelectionModel: any,
  setOpenClear: any,
  setConfirmClear: any,
  setOpenLoad: any,
) {
  const { whoAmI } = useUserContext()
  const { currentHolding } = useHoldingContext()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse, string[], any>({
    mutationFn: (barcodes) =>
      PyAPI.post(whoAmI!, '/reader/confirm_barcodes', {
        barcodes: barcodes,
      }),
    onError: (err) => setError(err),
    onSuccess: (data) => {
      setContainerSelectionModel((r: any) => [
        ...new Set([
          ...r,
          ...Object.entries(data.containers?.found)
            .filter(
              ([id, container]: any) =>
                container.HoldingID === currentHolding.value,
            )
            .map(([id, container]) => parseInt(id)),
        ]),
      ])
      setVesselSelectionModel((r: any) => [
        ...new Set([
          ...r,
          ...Object.entries(data.vessels?.found)
            .filter(([id, vessel]: any) => vessel.HoldingID !== -1)
            .map(([id, vessel]) => id),
        ]),
      ])
      setOpenLoad(false)
      if (sourceBatch) {
        setOpenClear(true)
        setConfirmClear(true)
      }
    },
  })
}
